<template>
  <el-container>
    <el-header>
      <common-header></common-header>
    </el-header>
    <div class="banner banner2">
      <div class="maincontainer">
        <div class="icondetail"></div>
        <div class="title">{{ $t('lang.applyDetail.title') }}</div>
      </div>
    </div>
    <el-main>
      <div class="maincontainer">
        <div class="requestinfo">
          <div class="requestno">{{ $t('lang.applyDetail.applyNo') + applyVo.applyNo }}</div>
          <div class="requestdate">{{ $t('lang.applyDetail.applyTime') + dateFormatter(applyVo.applyTime, 2) }}</div>
        </div>
        <paper-apply-detail v-if="applyVo.applyType === 'PAPER'" :apply-vo="applyVo"></paper-apply-detail>
        <electronic-apply-detail v-else-if="applyVo.applyType === 'ELECTRONIC'"
                                 :apply-vo="applyVo"></electronic-apply-detail>
      </div>
      <div class="maincontainer">
        <pay-info :apply-vo="applyVo"></pay-info>
      </div>
      <div class="maincontainer" style="padding-top:20px">
        <el-button
          size="mini"
          style="width: 250px"
          type="ceibsprimary"
          @click="goto('applyList')">
          {{ $t('lang.common.back') }}
        </el-button>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import CommonHeader from '@/components/common/commonHeader'
import { find } from '@/api/apply'
import { formatDate } from '@/util/util.date'
import PaperApplyDetail from '@/views/apply/record/component/paperApplyDetail'
import ElectronicApplyDetail from '@/views/apply/record/component/electronicApplyDetail'
import PayInfo from '@/views/apply/record/component/payInfo'
import { mapGetters } from 'vuex'
import { getAccessToken, getRefreshToken } from '@/util/util.ruquest'

export default {
  components: { PayInfo, ElectronicApplyDetail, PaperApplyDetail, CommonHeader },
  data () {
    return {
      applyVo: {}
    }
  },
  computed: {
    ...mapGetters([
      'quickQueryApplyId'
    ]),
    isLogin: function () {
      return getAccessToken() && getRefreshToken()
    }
  },
  mounted () {
    if (!this.isLogin && !this.quickQueryApplyId) {
      this.$router.push('/')
    }
    this.initData(this.$route.query.id)
  },
  methods: {
    goto (url) {
      this.$router.push(url)
    },
    initData (id) {
      find({
        id: id
      }).then(res => {
        this.applyVo = res.data
      })
    },
    dateFormatter (val, type = 1) {
      return formatDate(val, type)
    }
  }
}
</script>

<style scoped>
/deep/ .el-collapse {
  border: none;
}

/deep/ .el-collapse-item {
  position: relative;
  margin-bottom: 25px;
}

/deep/ .el-collapse-item__header {
  background-color: #848484;
  color: #fff;
  text-align: center;
  display: block;
  border-left: 5px solid #a2100e;
  border-bottom: none;
  font-size: 16px;
  height: 35px;
  line-height: 35px;
  box-shadow: -1px 3px 11px 2px rgb(136 136 136 / 51%);
  position: relative;
}

/deep/ .el-collapse-item__header.is-active {
  background-color: #a2100e;
}

/deep/ .el-collapse-item__header i {
  font-size: 12px;
  margin-left: 15px;
}

/deep/ .el-collapse-item__arrow {
  display: none;
}

/deep/ .el-icon-arrow-right::before {
  content: "";
}

/deep/ .el-collapse-item__wrap {
  border: none;
}

.requestinfo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 20px;
  padding-left: 15px;
  padding-right: 15px;
}

.requestno {
  color: #a2100e;
}

.requestdate {
  color: #6a6c71;
}

.itemtitle {
  background: #a2100e;
  color: #fff;
  text-align: center;
  height: 35px;
  line-height: 35px;
  box-shadow: -1px 3px 11px 2px rgb(136 136 136 / 51%);
}

.filelist .rowheader {
  font-size: 12px;
  color: #a2100e;
  padding: 10px 0 5px 0;
}

.filelist .filerow {
  margin: 5px 0;
  font-size: 12px;
  line-height: 35px;
  color: #707070;
}

.filelist .filerow:nth-child(even) {
  background: #ededed;
}

/deep/ .el-button--text {
  color: #606266;
}

/deep/ .el-button--text i {
  color: #a2100e;
  margin-left: 5px;
  font-size: 18px;
}

/deep/ .el-button--text span {
  display: flex;
  align-items: center;
}

.totalinfo {
  margin-top: 20px;
  background: #d2d2d2;
  padding: 15px;
  font-weight: bold;
  font-size: 18px;
  color: #5b5b5b;
  text-align: left;
}

.totalinfo span {
  color: #a2100e;
}

.totalinfoext {
  margin-top: 20px;
  background: #d2d2d2;
  padding: 15px;
  font-weight: bold;
  font-size: 18px;
  color: #5b5b5b;
  text-align: left;
}

.totalinfoext .extred {
  color: #a2100e;
  display: block;
  line-height: 50px;
}

.flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.itemtotalinfo {
  background: #ededed;
  padding: 15px;
  font-weight: bold;
  font-size: 12px;
  color: #5b5b5b;
  text-align: left;
}

.itemtotalinfo .iteminforesult {
  font-size: 16px;
  color: #a2100e
}
</style>
